const FavoriteCardSkeleton = () => {
  return (
    <div className="category-card favorite-card skeleton-card">
      <div className="skeleton-image"></div>
      <div className="category-info">
        <div className="skeleton-text skeleton-title"></div>
      </div>
      <div className="skeleton-favorite-button"></div>
    </div>
  )
}

export default FavoriteCardSkeleton
